export const yen = (n) =>
  "¥" + Math.round(n).toLocaleString("ja-JP");

export const brl = (n) =>
  "R$ " + Math.round(n).toLocaleString("pt-BR");

export const usd = (n) =>
  "$" + Math.round(n).toLocaleString("en-US");

export const pct = (n, decimals = 1) =>
  n.toFixed(decimals) + "%";

export const compact = (n) => {
  if (n >= 100_000_000) return (n / 100_000_000).toFixed(1) + "億";
  if (n >= 10_000) return (n / 10_000).toFixed(1) + "万";
  return n.toLocaleString();
};
